const MuiTextField = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: "100%",

      ".MuiInputBase-root": {
        backgroundColor: theme.palette.modules.input,
        borderRadius: "8px",
        paddingLeft: 0,

        ".MuiInputBase-input": {
          textAlign: "inherit",
          height: "24px",
          "&::placeholder ": {
            fontSize: "12px",
          },
        },

        color: theme.palette.text.main,
      },

      ".Mui-focused": {
        "&:not(.MuiFormHelperText-root)": {
          border: `1px solid ${theme.palette.info.lightest}`,
        },
        "&.MuiFormHelperText-root" :{
          border: `1px solid transparent`,
        }
      },

      ".MuiFormHelperText-root": {
        textAlign: "inherit",
        direction: "rtl",
      },

      fieldset: {
        border: "none !important",
      },
    }),
  },

  // defaultProps: {
  //   dir: "rtl",
  // },
};

export default MuiTextField;
